<template>
<section id="relatorio">
	<container>

		<flash-message message="This is a flash message" type="error" v-show="isFlashMessageVisible" @close="() => this.isFlashMessageVisible = false" />

		<div class="submit-form">
			<button-submit class="large" type="button" :onClick="onClickExportBooksToXLS" >
				<load-submit v-if="loadingSubmit"></load-submit>
				<span v-else>EXPORTAR LIVROS</span>
			</button-submit>
		</div>

	</container>

</section>
</template>

<script>
import container from '@/components/shared/Container'
import LoadSubmit from '@/components/shared/LoadSubmit'
import ButtonSubmit from '@/components/shared/ButtonAction'
import { objetos } from '@/services/objetos'

export default {
	name: 'Relatorio',
	components: { container, LoadSubmit, ButtonSubmit },
	data () {
		return {
			loadContent: true,
			params: {},
			isFlashMessageVisible: false,
			loadingSubmit: false
		}
	},
	methods: {
		activeFlashMessage () {
			this.isFlashMessageVisible = true

			setTimeout(() => {
				this.isFlashMessageVisible = false
			}, 2000)
		},

		onClickExportBooksToXLS (event) {
			objetos.getPDF('exportar?tipo=livro', 'Relacao-de-Livros.xlsx')
		}
	}
}
</script>

<style lang="scss" scoped>
 #area {
	.table-wrapper {

		.table {
			display:flex;
			padding: 5px 0px 5px;
			color: $main-color;
			font-weight: $font-weight-default-bolder;

			.fields {
				&:nth-child(odd) {
					background-color:#C7D2DF;
				}

				td {
					&.delete {
						width: 40px;
						text-align: right;
					}
				}
			}
		}
	}
	.submit {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}
}
</style>
